<template>
    <app-layout title="View Credit Request">
        <page-header>
            <template #title>View Credit Request</template>

            <template #actions>
                <jet-button 
                    v-if="refund.status === 'new' || (isAdmin && (refund.status === 'rejected' || refund.status === 'refunded' || refund.status === 'closed_no_refund'))"
                    :href="`/refunds/${refund.id}/edit`"
                >
                    Edit
                </jet-button>
                <jet-tertiary-button type="button" class="leading-none" :href="backUrl">
                    Close
                </jet-tertiary-button>
            </template>
        </page-header>

        <div class="flex flex-col md:px-4 lg:px-8 gap-y-4 ">
            <refund-details
                :form="form"
                :order="refund.order"
                :isCreate=false
                :refund="refund"
            />
            <refund-product-details
                :form="form"
                :refund="refund"
                :refund_items="refund_items"
            />
        </div>
    </app-layout>
</template>

<script>
import { usePage, Link } from '@inertiajs/inertia-vue3';
import UseUserAuth from '@/Composables/UseUserAuth';
import AppLayout from '@/Layouts/AppLayout.vue';
import { DateTime } from "luxon";
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetLabel from '@/Jetstream/Label';
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetDropdown from '@/Jetstream/Dropdown';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import RefundProductDetails from '@/Pages/Refund/Partials/RefundProductDetails.vue';
import RefundDetails from '@/Pages/Refund/Partials/RefundDetails.vue';

export default {
    setup () {
        const { isAdmin, isCustomer } = UseUserAuth(usePage().props.value.user);

        return { isAdmin, isCustomer }
    },

    components: {
        Link,
        AppLayout,
        PageHeader,
        RefundDetails,
        JetLabel,
        JetButton,
        JetConfirmationModal,
        JetSecondaryButton,
        JetDangerButton,
        JetDialogModal,
        JetDropdown,
        JetTertiaryButton,
        RefundProductDetails,
    },

    props: [
        'refund',
        'form',
        'refund_items'
    ],

    data() {
        return {
            showRefundModal: false,
        }
    },

    methods: {
        formatDate (date) {
            if (!date) {
                return '-';
            }

            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        },
    },

    computed: {
        backUrl () {
            const params = route().params;

            if (params.return) {
                return params.return;
            }

            if (this.isCustomer)
            {
                return route('customer_refunds.index', {
                    page: this.$page.props.page.refunds,
                });
            }
            else
            {
                return route('refunds.index', {
                    page: this.$page.props.page.refunds,
                });
            }
        },
    }
}
</script>

<style scoped>

</style>
